import styled from 'styled-components';

export const Ranks = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
`;

export const Rank = styled.div`
  display: flex;
  flex: none;
`;

export const RankHeader = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;

export const RankTitle = styled.div`
  font-weight: 700;
  font-size: 16px;
  @media (max-width: 800px) {
    font-size: 13px;
  }
`;

export const RankSubTitle = styled.div`
  color: #5a5a5a;
  font-size: 12px;
  @media (max-width: 800px) {
    font-size: 10px;
  }
`;

export const Separator = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  @media (max-width: 800px) {
    display: none;
  }
`;

export const DashedLine = styled.div`
  border-bottom: 1px dashed #5a5a5a;
  width: 100%;
  margin: 0 0 0 20px;
`;

export const CompleteRankTitle = styled.div`
  text-transform: uppercase;
  color: #a9a9a9;
  font-weight: 700;
  margin-bottom: 12px;
`;

export const RankWrapper = styled.div`
  box-shadow: ${(props) => props.theme.shadows.shadowXS};
  border-radius: 16px;
  padding: 40px;
  margin-bottom: 40px;
  background-color: ${({ theme }) => theme.colors.neutral50};
  @media (max-width: 800px) {
    padding: 20px;
    box-shadow: none;
  }
`;

export const UsersList = styled.div``;

export const TableRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 20px 0;
  font-size: 17px;
  color: ${(props) => props.theme.colors.neutral900};
  border-bottom: 1px solid ${(props) => props.theme.colors.neutral400}50;
`;

export const TableHead = styled.div`
  color: #a9a9a9;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
`;

export const TableData = styled.div``;

export const Percentage = styled.span`
  font-weight: 700;
  font-size: 14px;
  color: ${(props) =>
    props.percentage
      ? props.theme.colors.error500
      : props.theme.colors.success500};
`;

export const NoUserMessage = styled.div`
  text-align: center;
  margin-top: 45px;
  font-size: 22px;
  font-weight: 700;
`;

export const BoardContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #569f8c1a;
`;

export const BoardHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const Collapsable = styled.div`
  opacity: ${(props) => (props.expanded ? '1' : '0')};
  max-height: ${(props) => (props.expanded ? '2000px' : '0')};
  overflow: scroll;
  transition: all 500ms;
  margin-bottom: ${(props) => (props.expanded ? '10px' : '0')};
`;

export const BoardHeaderLeft = styled.div`
  display: flex;
`;

export const BoardHeaderRight = styled.div`
  display: flex;
`;

export const Level = styled.div`
  width: 100%;
  height: 63px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;

  transition: 0.5s all ease;
  cursor: pointer;
`;
